import type { RouteLocation } from 'vue-router';

export default (link?: string | RouteLocation): boolean =>
  typeof link === 'string' ? /^(https?|tel|mailto):/.test(link ?? '') : false;
